import React from 'react';

const buildVisiblePages = (currentPage, totalPages) => {
    if (totalPages <= 1) return [1];

    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, start + 4);
    const normalizedStart = Math.max(1, end - 4);

    return Array.from({ length: end - normalizedStart + 1 }, (_, index) => normalizedStart + index);
};

export const TablePagination = ({
    total,
    limit,
    offset,
    hasNext,
    hasPrev,
    onOffsetChange,
    isLoading,
}) => {
    const safeLimit = limit > 0 ? limit : 10;
    const totalPages = Math.max(1, Math.ceil(total / safeLimit));
    const currentPage = Math.floor(offset / safeLimit) + 1;

    const rangeStart = total === 0 ? 0 : offset + 1;
    const rangeEnd = total === 0 ? 0 : Math.min(offset + safeLimit, total);

    const goToPage = (page) => {
        const normalizedPage = Math.max(1, Math.min(page, totalPages));
        const nextOffset = (normalizedPage - 1) * safeLimit;
        onOffsetChange(nextOffset);
    };

    const visiblePages = buildVisiblePages(currentPage, totalPages);

    return (
        <div className="customer-pagination mt-3">
            <p className="customer-pagination__summary mb-0">
                Mostrando {rangeStart} a {rangeEnd} de {total} registros
            </p>

            <div className="customer-pagination__controls">
                <button
                    type="button"
                    className="customer-pagination__button"
                    disabled={!hasPrev || isLoading}
                    onClick={() => goToPage(currentPage - 1)}
                >
                    Anterior
                </button>

                {visiblePages.map((page) => (
                    <button
                        key={page}
                        type="button"
                        className={`customer-pagination__button ${page === currentPage ? 'is-active' : ''}`}
                        onClick={() => goToPage(page)}
                    >
                        {page}
                    </button>
                ))}

                <button
                    type="button"
                    className="customer-pagination__button"
                    disabled={!hasNext || isLoading}
                    onClick={() => goToPage(currentPage + 1)}
                >
                    Siguiente
                </button>
            </div>
        </div>
    );
};
